import { render } from "./TouchTheBottom.vue?vue&type=template&id=e6a975ae&scoped=true"
import script from "./TouchTheBottom.vue?vue&type=script&lang=js"
export * from "./TouchTheBottom.vue?vue&type=script&lang=js"

import "./TouchTheBottom.vue?vue&type=style&index=0&id=e6a975ae&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6a975ae"]])

export default __exports__